module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[106]349.29c8854.woff2";